// src/components/onboarding/screens/MetiersScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { RadioItem, SectionBox, ScreenTitle } from '../OnboardingUI';
import { metiersAvantOptions, metiersAvantOptionsLabel, metiersAujourdhuiOptions, TOTAL_STEPS } from '../onboardingData';

const MetiersScreen = ({ metiersAvant, genre, metiersAujourdhui, onChange, onNext, loading, error }) => {
  const canProceed = metiersAvant !== '' && metiersAujourdhui !== '';

  return (
    <OnboardingLayout
      currentStep={3}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle title="Côté métiers, tu en es où ?" />

      <SectionBox variant="gray" icon="⏪" label={metiersAvantOptionsLabel(genre)}>
        {metiersAvantOptions.map(option => (
          <RadioItem
            key={option.value}
            checked={metiersAvant === option.value}
            label={option.label}
            onClick={() => onChange({ metiersAvant: option.value, metiersAujourdhui })}
            disabled={loading}
          />
        ))}
      </SectionBox>

      <SectionBox variant="emerald" icon="📍" label="Aujourd'hui">
        {metiersAujourdhuiOptions.map(option => (
          <RadioItem
            key={option.value}
            checked={metiersAujourdhui === option.value}
            label={option.label}
            onClick={() => onChange({ metiersAvant, metiersAujourdhui: option.value })}
            disabled={loading}
          />
        ))}
      </SectionBox>
    </OnboardingLayout>
  );
};

export default MetiersScreen;
